import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://dolftech.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token to all requests
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage directly to avoid circular dependency
    const token = localStorage.getItem('access_token');
    const tokenType = localStorage.getItem('token_type') || 'Bearer';
    
    if (token) {
      config.headers.Authorization = `${tokenType} ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, clear localStorage
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
      // Reload the page to reset the app state
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default apiClient;


